module.exports = __webpack_public_path__ + "img/JHSLS_Android.505c48b6.png";